import useResponsive from 'src/hooks/useResponsive';

export default function Mobile({ children }: any) {
  return useResponsive('down', 'sm') ? children : null;
}
